import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0db33152&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=0db33152&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports